import {
    WasteResourceENVIcon,
    watermanagementENVIcon,
    PlantationSustainabilityENVIcon,
    EnergyConsumptionENVIcon,
    EmissionsCarbonENVIcon,
    AirQualityENVIcon,
    Component21,
    Component22,
    Component23,
    Component24,
    Component25,
    Component26,
} from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import SolutionFourCardSwapSection from "../../components/SolutionFourCardSwapSection";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import GraphViewSection from "../../components/GraphViewSection";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import EnvironmentManagementLanding from "../../components/Solution/EnvironmentLanding";
import TogetherSection from "../../components/Solution/TogetherChange";




const AnimatedCardCrausalData = [
    {
        icon: AirQualityENVIcon,
        title: "Air Quality Monitoring",
        description:
            "Continuously monitor PM1, PM2.5, PM10, SOx, NOx, CO₂, VOCs and other environmental parameters to ensure regulatory compliance and healthier work environments.",
        data: "IOT enabled to capture real time data for better performance.IOT enabled to capture real time data for better performance."
    },
    {
        icon: EmissionsCarbonENVIcon,
        title: "Emissions & Carbon Tracking",
        description:
            "Track stack emissions, greenhouse gas emissions and carbon footprints with intelligent dashboards that support ESG reporting and sustainability initiatives.",
        data: "IOT enabled to capture real time data for better performance."
    },
    {
        icon: EnergyConsumptionENVIcon,
        title: "Energy Consumption Intelligence",
        description: "Analyze energy utilization patterns across facilities, identify abnormal consumption trends and improve operational efficiency through AI-powered energy analytics.",
        data: "IOT enabled to capture real time data for better performance.IOT enabled to capture real time data for better performance."
    },

    {
        icon: WasteResourceENVIcon,
        title: "Waste & Resource Management",
        description: "Monitor waste generation, disposal activities, recycling performance and resource utilization to support sustainable waste management practices.",
        data: "IOT enabled to capture real time data for better performance.IOT enabled to capture real time data for better performance."
    },
    {
        icon: watermanagementENVIcon,
        title: " Water Quality & Consumption Monitoring",
        description: "Track water quality parameters, water usage patterns and discharge levels in real time to improve conservation and environmental compliance.",
        data: "IOT enabled to capture real time data for better performance.IOT enabled to capture real time data for better performance."
    },
    {
        icon: PlantationSustainabilityENVIcon,
        title: "Plantation & Sustainability Initiative Tracking",
        description: "Digitally manage plantation drives, greenbelt development and environmental restoration initiatives with centralized sustainability dashboards and progress monitoring.",
        data: "IOT enabled to capture real time data for better performance.IOT enabled to capture real time data for better performance."
    },
];

const slidesData = [

    {
        viewData: [
            {
                imgUrl: [Component21],
            },
            {
                imgUrl: [Component22],
            },
            {
                imgUrl: [Component23],
            },
            {
                imgUrl: [Component24],
            },
            {
                imgUrl: [Component25],
            },
            {
                imgUrl: [Component26],
            },
           
        ],

        menuItems: [{
            title: "Ambient Air Monitoring",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Stack Emissions",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Water Monitoring ",
            Icons: DashboardOutlinedIcon,
        },
        {
            title: "Noise & Vibration",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Waste Management",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Regulatory Compliance",
            Icons: InsertChartOutlinedIcon,
        },
        ],
    }


];



const FourCardsSwapcardData = [
    {
        title: "Real-Time Environmental Insights",
        description:
            "Powered by IoT, AI and intelligent environmental monitoring technologies",
    },
    {
        title: "Simplified Compliance & ESG Reporting",
        description:
            "Enable proactive ESG management and environmental compliance visibility",
    },
    {
        title: "Customizable Sustainability Dashboards ",
        description:
            "Flexible and scalable dashboards for enterprise-wide environmental intelligence.",
    },
];

const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];




export default function SolutionEnvironmentManagement() {
    return (
        <>
            <EnvironmentManagementLanding />
            <AnimatedCardCrausal
                title={"Environmental Intelligence That Drives Sustainable Operations."}
                subTitle={"Enable smarter environmental management with real-time monitoring, AI-driven analytics and connected sustainability insights across industrial operations."}
                data={AnimatedCardCrausalData}
            />
            <GraphViewSection
                title={"Intelligent Environmental Dashboards Built for Smarter Decisions"}
                subTitle={"Our environmental management dashboards provide real-time visibility into emissions, air quality, energy usage, waste generation and sustainability performance across industrial operations. Designed for enterprises and industrial facilities, the platform enables centralized environmental monitoring, AI-driven analytics and actionable insights to support compliance, ESG reporting and sustainable operational excellence."}
                data={slidesData}
            />
            <SolutionFourCardSwapSection
                title={"Smarter Environmental Intelligence for Sustainable Operations"}
                subTitle={"Gain real-time insights, enhance productivity, and drive performance with data-driven decision-making and transparent evaluations."}
                cardData={FourCardsSwapcardData}
            />



            <WeAreIED />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <TogetherSection title={"Driving Sustainable Change, Together"}
                subTitle={"IENERGY empowers organizations with intelligent environmental management solutions that help monitor, optimize and improve sustainability performance across operations. From real-time environmental monitoring and compliance management to energy optimization, emissions tracking and ESG reporting, our platform enables smarter, data-driven decisions for a greener and more sustainable future."}
            />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
